<adaa-data-table
    [titleHeader]="'breadcrumbs.user_related_objects'"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.USER_RELATED_OBJECTS"
    [apiName]="'getAllPermissionsByUserId'"
    [paramsString]="id()"
    [enableAdd]="false"
    [enableDeleteAction]="false"
    [enableEditAction]="false"
    [hideViewRules]="hideViewRules"
    (actionClicked)="actionClicked($event)"
></adaa-data-table>
